module.exports = __webpack_public_path__ + "img/google-otp.1c62fd31.svg";